import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import PageContainer from "../../components/PageContainer/PageContainer";
import { Box, Button } from "@mui/material";
import { PendienteIcon, MercadoPagoImg } from "assets";
import { URLs } from "utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";

function TarjetaPagoPendiente() {
  const classes = useStyles();
  const navigate = useNavigate();
  const modal = {
    open: true,
    showX: false,
    img: PendienteIcon,
    content: (
      <Box className={classes.modalContentDynamic}>
        <p
          className={classes.modalTitle}
          style={{ width: "95%", marginTop: "15px" }}
        >
          Tu pago está{" "}
          <span style={{ color: "#04808F" }}>pendiente de aprobación.</span>{" "}
          Ingresá en unos instantes para verificarlo.
        </p>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginTop: "1rem",
          }}
        >
          <div className={classes.divBtn}>
            <Button
              className={`${classes.btnFull} ${classes.btnAzul}`}
              href={"https://www.mercadopago.com.uy/ "}
              target="_blank"
              variant="text"
              sx={{
                width: "200px",
              }}
            >
              {"PAGO ONLINE"}
              <img
                src={MercadoPagoImg}
                alt="Home Mobile"
                style={{
                  maxWidth: "50px",
                  maxHeight: "100%",
                  objectFit: "contain",
                  marginLeft: "0.5rem",
                }}
              />
            </Button>
          </div>
        </Box>
      </Box>
    ),
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  return (
    <>
      <PageContainer
        modal={modal}
        canonicalUrl={URLs.pendiente}
        noImage={true}
      ></PageContainer>
    </>
  );
}

export default TarjetaPagoPendiente;
